// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"5919ed9b","279":"878e415d"}[chunkId] + ".chunk.css";
};